import { ArrowRightOnRectangleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FC, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary,
  ButtonSecondary
} from "../../../components";
import { getTokenInsw, getVerifierInsw } from "../services/OAuth";
import jwtDecode from "jwt-decode";
import { createDataPuNIB, getsDataInquiryNIB } from "modules/Pu/services/DataNIB";
import { signUp } from "modules/Auth/services/AuthSlice";
import { signUpSaliha } from "modules/AuthSaliha/services/SalihaAuth";

// import { signIn, signOut } from "../services/AuthSlice";
// import { GET_AUTHSYSTEM } from "../services/AuthSystemSlice";


export interface PageOAuthProps {
  className?: string;
}


const OAuth: FC<PageOAuthProps> = ({ className = "" }) => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [decodeToken, setDecodeToken] = useState(
    {
      profile: {
        email: ""
      },
      organization: {
        nib: ""
      }
    }
  )

  const [searchParams, setSearchParams] = useSearchParams();
  const _role = searchParams.get("role")
  const _code = searchParams.get("code")
  const _state = searchParams.get("state")

  const {
    // isSuccessSignUp: isSuccessSignUpSalihaAuth,
    dataVerfier,
    isSuccessVerfier,
    isFetchingVerfier,

    dataToken,
    isSuccessToken,
    isFetchingToken,

    isError: isErrorOauth,
    errorMessage: errorMessageOauth
  } = useAppSelector((state) => state.oauth);

  const {
    dataInquiry: dataInquiryNIB,
    isSuccessInquiry: isSuccessInquiryNIB,
    isErrorInquiry: isErrorInquiry,

    isSuccessCreateDataPuNIB,
    dataCreatePuNIB,
    isFetchingCreateDataPuNib,

    isFetching: isFetchingInquiryNIB,
    errorMessage: errorMessageInquiryNIB
  } = useAppSelector((state) => state.inquiryNIB);

  const {
    // isSuccessSignUp: isSuccessSignUpSalihaAuth,
    dataUserInfo: dataUserInfoSaliha,
    isSuccessUserInfo,
    isSuccessSignUp,
    dataSignUp: dataSignUpSalihaAuth,
    isError: isErrorSalihaAuth,
    isFetching: isFetchingSalihaAuth,
    errorMessage: errorMessageSalihaAuth
  } = useAppSelector((state) => state.salihaAuthSlice);

  useEffect(() => {
    async function _getVerfierInsw() {
      if (_state) {
        dispatch(getVerifierInsw({
          State: _state
        }))
      }
    }

    _getVerfierInsw();

  }, [dispatch]);

  useEffect(() => {
    async function _getTokenInsw(code: string, code_verifier: string, state: string) {
      dispatch(getTokenInsw(
        {
          GET_TOKEN: {
            State: state,
            Code: code,
            CodeVerifier: code_verifier
          }
        }
      ))
    }

    if (isSuccessVerfier && _code && _state) {
      _getTokenInsw(_code, dataVerfier.GET_VERIFIER.data.value, _state)
    }

  }, [dispatch, isSuccessVerfier]);

  useEffect(() => {
    async function _checkInquiryNIB(nib: string) {
      if (nib) {
        dispatch(getsDataInquiryNIB({
          filter: { nib: nib }
        }))
      }
    }

    console.log(isSuccessToken)

    if (isSuccessToken) {
      var token = dataToken.GET_TOKEN.data.id_token

      let decode = {
        profile: {
          email: ""
        },
        organization: {
          nib: ""
        }
      }

      decode = jwtDecode(token)
      setDecodeToken(decode)

      _checkInquiryNIB(decode.organization.nib)
    }

  }, [dispatch, isSuccessToken]);

  useEffect(() => {
    async function _checkSignUp() {
      dispatch(signUpSaliha({
        REGISTER: {
          emailAddr: decodeToken.profile.email,
          nama: dataInquiryNIB.GETS_INQUIRYNIB.data.namaPerseroan,
          role: "R.10",
          password: decodeToken.organization.nib,
        }
      }))
    }

    if (isSuccessInquiryNIB) {
      _checkSignUp()
    }

  }, [dispatch, isSuccessInquiryNIB]);

  useEffect(() => {
    async function _createDataPuNib() {
      dispatch(createDataPuNIB({
        CREATE_PU: {
          Nib: decodeToken.organization.nib,
          UnikId: dataSignUpSalihaAuth.REGISTER.data.unik_id,
          UserId: dataSignUpSalihaAuth.REGISTER.data.userid
        }
      }))
    }

    if (isSuccessSignUp) {
      _createDataPuNib()
    }

  }, [dispatch, isSuccessSignUp]);

  useEffect(() => {

    if (isSuccessCreateDataPuNIB) {
      window.location.replace(`http://localhost:55660/auth?grant=OAUTH&username=` + dataSignUpSalihaAuth.REGISTER.data.userid);
    }

  }, [dispatch, isSuccessCreateDataPuNIB]);

  // const doSelanjutnnyya = () => {
  //   if (true) {

  //     // window.location.replace(`https://localhost:55660/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegistration.CREATE_REGISTRATION
  //     //   .data.IdReg}&channel_id=CH003`);
  //   }
  // }

  return (
    <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
      <div className="container h-screen flex w-full justify-center ">

        <div className="mx-auto max-w-2xl mt-10">
          <div className="rounded-xl bg-gray-50 min-full">
            <div className="rounded-xl bg-white p-5 pb-20 text-white">
              <div className="w-full flex flex-row justify-start space-x-5 items-center">
                <img
                  className={`block max-h-16`}
                  src={logoImg}
                  alt="Logo"
                />
              </div>

            </div>

            {
              (isErrorOauth || isErrorInquiry || isErrorSalihaAuth) ? (
                <section className="p-5">
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <strong className="font-bold">Terjadi Kesalahan</strong>
                    <span className="block sm:inline"></span>
                  </div>
                </section>
              ) : (
                <section className="p-5">
                  <div className=" flex items-center justify-start gap-2 text-gray-600">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="3"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Mohon tunggu
                  </div>
                </section>
              )
            }






          </div>
        </div>

      </div>

    </div>
  );
};

export default OAuth;
